import TabsComponent from 'rc-tabs';
import styled from 'styled-components';

import TabPane from './TabPane';

const Tabs = styled(TabsComponent)`
  .rc-tabs-nav-list {
    display: flex;
    cursor: pointer;
    .rc-tabs-tab {
      padding: 15px 15px 0px;
      font-size: 14px;
      font-weight: 400;
      line-height: 17px;
      color: ${({ theme }) => theme.colors.dark[60]};
      &:hover {
        color: ${({ theme }) => theme.colors.dark[80]};
      }
      &.rc-tabs-tab-active {
        color: ${({ theme }) => theme.colors.dark[80]};
        border-bottom: 2px solid ${({ theme }) => theme.colors.primary[600]};
        .rc-tabs-tab-btn {
          padding-bottom: 4px;
        }
      }
    }
  }

  .rc-tabs-nav-operations,
  .rc-tabs-ink-bar {
    display: none;
  }
  .rc-tabs {
    font-size: 14px;
    overflow: hidden;
  }
  .rc-tabs-nav {
    flex: none;
    position: relative;
    margin-bottom: 50px;
  }

  .rc-tabs-nav-measure,
  .rc-tabs-nav-wrap {
    transform: translate(0);
    position: relative;
    display: inline-block;
    flex: auto;
    white-space: nowrap;
    overflow: hidden;
    display: flex;
  }
`;

export { TabPane };

export default Tabs;
